const REFERRING_DOMAIN = 'referring_domain';

const UTM_SOURCE = 'utm_source';
const UTM_MEDIUM = 'utm_medium';
const UTM_CAMPAIGN = 'utm_campaign';
const UTM_TERM = 'utm_term';
const UTM_CONTENT = 'utm_content';

const REFERRER = 'referrer';
const SRC = 'src';
const FROM = 'from';
const REF = 'ref';

export {
  REFERRING_DOMAIN,
  UTM_SOURCE,
  UTM_MEDIUM,
  UTM_CAMPAIGN,
  UTM_TERM,
  UTM_CONTENT,
  REF,
  REFERRER,
  FROM,
  SRC,
};
